export default __webpack_public_path__ + "static/media/wallet.6e4985ab.svg";